import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  CommunityPlayersRepo,
  CommunityPlayersQuery,
  CommunityPlayersPage,
} from "@app/core/community/domain/community-players.repo";
import { CommunityPlayersWS } from "@app/core/community/data/network/community-players.ws";

@Injectable()
export class CommunityPlayersDataRepo implements CommunityPlayersRepo {
  constructor(private ws: CommunityPlayersWS) {}

  getPlayers(query: CommunityPlayersQuery): Observable<CommunityPlayersPage> {
    return this.ws.getPlayers(query);
  }
}
